import { createApi } from "@reduxjs/toolkit/query/react";
import { queryParams } from "../../../utils/helper";
import { baseQueryWithAuth } from "../../BaseQueryWithAuth/baseQueryWithAuth";

export const digitalProductsApiService = createApi({
  reducerPath: "digitalProductsApi",
  baseQuery: baseQueryWithAuth,
  endpoints: (builder) => ({
    getDigitalProducts: builder.query({
      query: (data) => {
        if (data?.id) return `digital-product/get/${data?.id}`;
        let query = queryParams(data);
        return `digital-product/get${query}`;
      },
      keepUnusedDataFor: 0,
    }),

    buyProduct: builder.mutation({
      query: ({ id, params }) => {
        let query = queryParams(params);
        return {
          url: `digital-product/buy/${id}${query}`,
          method: "POST",
        };
      },
    }),

    getPurchasedProduct: builder.query({
      query: ({ params }) => {
        let query = queryParams(params);
        return {
          url: `digital-product/get/pss${query}`,
          method: "GET",
        };
      },
      keepUnusedDataFor: 0,
    }),
  }),
});

export const {
  useGetDigitalProductsQuery,
  useBuyProductMutation,
  useGetPurchasedProductQuery,
} = digitalProductsApiService;
